import { USER_ROLES } from "@/mappings/user-roles";

export default [
    {
        path: 'all',
        name: 'tasks',
        component: (): Promise<any> => import('@/views/tasks/TasksList.vue'),
        meta: {
            title: 'Мои задачи',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.NOTIFICATION_MANAGER, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.FINMEDIA, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
    {
        path: 'task/:id',
        name: 'task',
        component: (): Promise<any> => import('@/views/tasks/TaskSingle.vue'),
        meta: {
            title: 'Задача',
            requiresAuth: true,
            roles: [USER_ROLES.ADMIN, USER_ROLES.NOTIFICATION_MANAGER, USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.FINANCIER, USER_ROLES.SUPERVISOR, USER_ROLES.FINMEDIA, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR, USER_ROLES.NEW_AFFILIATE_MANAGER,
            ],
        },
    },
];
